var rider = {};
var model = {};
var bikeData = [];
var ratio = 0;
var avatar = 'no hair';
var saddleHeightSlider = 0;
var imageContainer = {
  height: 0,
  width: 0
}
 var bikeSpecs = {
  angle: 0,
  gripStack: 0,
  gripReach: 0,
  handleOffset: 0
}

var bb = {   // this is the location of the bb. should really be calculated based on the actual bb of the bike in mm
  x: 0,
  y: 0
}
let imageShrinkRatio;

const bikeImage = document.querySelector('.bike-image_image');
const saddleHeightControl = document.getElementById('saddle-height-control');

const saddleReadOut = document.getElementById('saddle-read-out');
const torsoReadOut = document.getElementById('torso-read-out');


// --------- fetch sheet data -------------
async function getSheetData() {
  // if (sessionStorage.getItem('priorityBikeSizes')) {
  //   console.log('loading from cookies');
  //   bikeData = JSON.parse(sessionStorage.getItem('priorityBikeSizes'));
  // } else {
    console.log('loading from sheet');
    const res = await fetch('https://sheets.googleapis.com/v4/spreadsheets/1WtitQRmGXRbTVYDxgiwsFgcaqBBIlsgPtxf83nAAUbM/values/Sheet1?key=AIzaSyBtOTgb3XWC5MPE3mPXsE7o-tm3EdsiG0g');
    const data = await res.json();
    if (data.values !== undefined) {
      bikeData = this.parseSheetData(data.values);
    }

    sessionStorage.setItem('priorityBikeSizes', JSON.stringify(bikeData));

  // }
  populateBikeSelect();
}

function parseSheetData(data) {
  data.shift();
  let allBikes = [];
  let currentModel = '';
  let modelObject = { // this gets populated with the sizes
    name: '',
    sizes: []
  }
  let loopIndex = 1;
  // loop through the spreadsheet, creating individual arrays of each model type with the different sizes in each array. then push those mini arrays to the main array
  data.forEach( (bike) => {
    if ( bike[0] != undefined ) {
      if ( bike[0] != currentModel ) { // if it is a new model
        // push the previous model to main array
        if ( modelObject.name != '' ) {
          allBikes.push(modelObject);
        }

        // reset model object
        modelObject = {
          name: '',
          sizes: []
        }

        // set name of model and add first bike
        currentModel = bike[0];
        modelObject.name = bike[0];
        modelObject.sizes.push(bike);
        
      } else if (loopIndex == data.length ) { // this makes sure last element is pushed to array
        modelObject.sizes.push(bike);
        allBikes.push(modelObject);
      } else { // if model is same as previous one
        // push bike to model sizes array
        modelObject.sizes.push(bike);
      } 
    }
    loopIndex ++;
  })

  return allBikes;
}

// ******* LOOP THROUGH ARRAY THAT WAS FETCHED AND USE IT TO BUILD THE SELECT MENU. 
function populateBikeSelect() {
  const bikeSelect = document.querySelector('#model');
  bikeData.forEach( (bike) => {
    const newOption = document.createElement('option');
    newOption.value = bike.name;
    newOption.text = bike.name;
    bikeSelect.add(newOption);
  })
}

// MAKE DEFAULT WINGSPAN SAME AS HEIGHT
const heightSelect = document.getElementById('height');
heightSelect.addEventListener('change', function() {
  document.getElementById('wingspan').value = heightSelect.value;
})

// FIND THE MATCHING BIKE IN THE BIKEDATA OBJECT/ARRAY

function findSizeMatch() {
  // get model from dropdown
  const bikeSelect = document.querySelector('#model');
  const selectedModel = bikeData.find( (model) => model.name == bikeSelect.value );
  
  // get height, inseam, wingspan dimensions
  rider.height = document.getElementById('height').value;
  rider.inseam = document.getElementById('inseam').value;
  rider.wingspan = document.getElementById('wingspan').value;


  // loop through sizes in the bike array and check inseam and height matches
  var analyzedSizes = [];
  var sizesChecked = false;
  selectedModel.sizes.forEach( (bike) => {
    let modelData = {
      inseam: Number,
      inseamMatch: false,
      height: Number,
      heightMatch: false,
      model: [],
      match: false
    }

    modelData.model = bike;

    //check inseam
    if ( rider.inseam >= bike[3] && rider.inseam <= bike[4] ) {
      modelData.inseamMatch = true
      modelData.inseam = 0
    } else if ( rider.inseam < bike[3] ) {
      modelData.inseam = rider.inseam - bike[3];
    } else if ( rider.inseam > bike[4] ) {
      modelData.inseam = rider.inseam - bike[4];
    }

    // check height
    if ( rider.height >= bike[5] && rider.height <= bike[6] ) {
      modelData.heightMatch = true
      modelData.height = 0
    } else if ( rider.height < bike[5] ) {
      modelData.height = rider.height - bike[5];
    } else if ( rider.height > bike[6] ) {
      modelData.height = rider.height - bike[6];
    }

    if (modelData.heightMatch && modelData.inseamMatch ) {
      modelData.match = true
    }

    analyzedSizes.push(modelData);
    sizesChecked = true
  })
  
  // load up size buttons and display model
  loadBikeResults(analyzedSizes);
}

function loadBikeResults(results) {

    // populate size buttons up top, one for each size

  const sizeButtonRow = document.querySelector('.size-btns');
  sizeButtonRow.innerHTML = '';
  var loopIndex = 0;
  results.forEach( (size ) => {
    var sizeButton = document.createElement('div'); 
    sizeButton.classList.add('match-btn');
    sizeButton.dataset.index = loopIndex;
    
    // add classes to set color of match button
    if ( size.match ) {
      sizeButton.classList.add('match');
    } else if ( size.heightMatch || size.inseamMatch ) {
      sizeButton.classList.add('partial-match');
    }

    loopIndex++;
    sizeButton.innerHTML = `
      <h4>${size.model[0]}</h4>
      <strong>${size.model[1]}</strong>
    `
    sizeButtonRow.appendChild(sizeButton);
  })

  // add listener to trigger model/size update on click, passing results through
  document.querySelectorAll('.match-btn').forEach( ( btn) => {
    btn.addEventListener('click', function(e) {
      updateModel(e, results);
    });
  })

  // cue up first matching bike and load it
  let firstLoadedBike = results.find(bike => bike.match == true)

  if (firstLoadedBike) { // if a match is found, load it first
    model = firstLoadedBike;
  } else { // otherwise load first element in array
    firstLoadedBike = results.find(bike => bike.heightMatch == true)
    if (firstLoadedBike) {
      model = firstLoadedBike;
    } else {
      model = results[0];
    }
  }

  updateModel(null, null, model);

}

// update bike image and model layout, receives button event click and results array with analyzed sizes
function updateModel(e, results, newModel) {

  // remove active class from buttons
  const matchBtns = Array.from(document.querySelectorAll('.match-btn'));
  matchBtns.forEach( (btn) => { 
    btn.classList.remove('active');
  });

  // check if the model is being passed directly
  let clickedBtn;

  if ( newModel ) {
    model = newModel; 
    matchBtns.forEach( (btn) => {
      if ( btn.querySelector('strong').innerHTML == model.model[1] ) {
        clickedBtn = btn;
      };
    });
  } else {
    clickedBtn = e.currentTarget;
    model = results[clickedBtn.dataset.index];
  }

  clickedBtn.classList.add('active');


  // update button state
  bikeImage.src = model.model[17];
  bikeImage.style.display = 'block';
  document.querySelector('.bike-placeholder').style.display = 'none';

  updateSliderRange();
  sizeContainer();
}

// ======================= SIZE BIKE CONTAINER

function sizeContainer() {
  // two ratios are used - first is the ratio of mm to pixels in the original image. this must be done from the xd and included in the spreadsheet.
  ratio = model.model[21];

  // then we see the size of the bike image container on screen
  const bikeContainer = document.querySelector('.bike-recommendations');
  imageContainer.width = bikeContainer.clientWidth;
  imageContainer.height = imageContainer.width;

  // then we set the height and the width of the bike image to the correct size
  const bikeImage = document.querySelector('.bike-image');
  bikeImage.style.height = imageContainer.height + 'px';
  bikeImage.style.width = imageContainer.width + 'px';

  // then, we calculate how much the image has shrunk to be rendered on screen. i.e., a 1000px original image size rendered at 500px has a .5 shrink ratio
  // we have to create a temporaray image element to get the width of it. this is not used to render, just retrieve width
  let tempImage = document.createElement('img');
  //tempImage.classList.add('test');
  //document.querySelector('.saddle-height').appendChild(tempImage);
  tempImage.src = model.model[17];
  imageShrinkRatio = imageContainer.width / 1000;
  
  // finally, adjust the original mm to px ratio by the image shrink ratio
  ratio *= imageShrinkRatio

  // now we have our two ratios. the mm to px ratio (ratio) and the image shrink ratio (imageShrinkRatio)
  // console.log('ratio is ' + ratio + ', image shrink ratio is ' + imageShrinkRatio)

  // now we take the bb x and y coordinates provided in the spreadsheet, and adjust based on the image shrink ratio to properly place the bb point
  
  bb.x = model.model[19] * imageShrinkRatio;
  bb.y = model.model[20] * imageShrinkRatio;
  
  drawShapes();
  // updateSaddleHeight();
}

// DRAW MODEL PARTS
function drawShapes() {
  setBikeSpecs(); // grab the proper bike dimensions based on the size chosen
  setLegs();
  legTriangle();
  setArms();
  setTorso();
  writeMessage();

  // set reference box, using height of crosbar of ltrain l which is 789 mm 
  const scaleBox = document.querySelector('.scale-box')
  scaleBox.style.height = 789 * ratio;
  scaleBox.style.width = 789 * ratio;
}

function setBikeSpecs() {
  bikeSpecs.angle = model.model[8];
  bikeSpecs.gripStack = model.model[9]
  bikeSpecs.gripReach = model.model[10]
  if ( model.model[11] == '' ) {
    bikeSpecs.handleOffset = 0
  } else {
    bikeSpecs.handleOffset = model.model[11]
  }
}

function setLegs(){
  // Ratio: this is the calculated scale of the model. the canvas is this.imageContainer.width x 1000, and the BB of the bike is 158px off the ground. in real life, the bb of the bike is 302 mm off the ground, so the ratio of mm to px is 158 / 302
  const legA = document.querySelector('.leg-a');
  const legB = document.querySelector('.leg-b');
  const legC = document.querySelector('.leg-c');


  // leg angle a
  legA.style.left = bb.x - ( dimensionA() * ratio) + 'px';
  legA.style.top = saddleAnchor().y + 'px';
  legA.style.right = (imageContainer.width - bb.x) + 'px';

  // leg angle b
  legB.style.left = bb.x + 'px';
  legB.style.bottom = bb.y + 'px';
  legB.style.top = saddleAnchor().y + 'px';

  // leg angle c
  legC.style.bottom = bb.y + 'px';
  legC.style.top = imageContainer.width - ( saddleHeightSlider * ratio ) - bb.y + 'px';
  legC.style.left = bb.x + 'px';

  const rotateDegrees = (90 - bikeSpecs.angle) * -1;
  legC.style.transform = 'rotate(' + rotateDegrees + 'deg)';
}

function legTriangle() {
  const legPartFemur = document.querySelector('.leg-triangle-femur');
  const legPartTibia = document.querySelector('.leg-triangle-tibia');
  const legFemur = document.querySelector('.leg-image-1');
  const legTibia = document.querySelector('.leg-image-2');
  const seat = document.querySelector('.seat');

  const legBB = (bb.y - (75 * imageShrinkRatio));
  //const saddleHeightAdjusted = saddleHeightSlider + (170*ratio) // need to adjust angle based on longer saddle height

  legPartHeight = inchesToMm( parseInt(rider.inseam) * 1.15) / 2;
  const adjustedSaddleHeight = ( Number(saddleHeightSlider) + 200);

  const legPartAngle = ( 57.2958 * Math.acos( ( ( legPartHeight**2 ) + ( adjustedSaddleHeight**2 ) - (legPartHeight ** 2) ) / ( 2 * legPartHeight * adjustedSaddleHeight ) ) ) ;

  const legFemurAngle = legPartAngle + ( 90 - bikeSpecs.angle );

  console.log(`legPartHeight is ${legPartHeight}, adjusted saddle height is ${adjustedSaddleHeight}, legPartAngle is ${legPartAngle}, legFemurAngle is ${legFemurAngle}, bikeAngle is ${bikeSpecs.angle}`);

  legPartFemur.style.top = saddleAnchor().y + 'px';
  legPartFemur.style.left = saddleAnchor().x + 'px';
  legPartFemur.style.height = ( legPartHeight * ratio ) + 'px';
  legPartFemur.style.transform = 'rotate(-' + legFemurAngle + 'deg)';
  legFemur.style.top = saddleAnchor().y + 'px';
  legFemur.style.left = saddleAnchor().x + 'px';
  legFemur.style.height = ( legPartHeight * ratio ) + 'px';
  legFemur.style.transform = 'rotate(-' + legFemurAngle + 'deg)';

  const legTibiaAngle = legPartAngle - ( 90 - bikeSpecs.angle ) + 9;
  legPartTibia.style.bottom = legBB + 'px';
  legPartTibia.style.left = bb.x + 'px';
  legPartTibia.style.height = ( legPartHeight * ratio ) + 'px';
  legPartTibia.style.transform = 'rotate(' + legTibiaAngle + 'deg)';
  legTibia.style.bottom = legBB + 'px';
  legTibia.style.left = bb.x + 'px';
  legTibia.style.height = ( legPartHeight * ratio ) + 'px';
  legTibia.style.transform = 'rotate(' + legTibiaAngle + 'deg)';

  // seat
  seat.style.top = saddleAnchor().y + 'px';
  seat.style.left = saddleAnchor().x + 'px';
  seat.style.height = imageContainer.width * .15 + 'px';
  const rotateDegrees = (90 - bikeSpecs.angle) * -1;
  seat.style.transform = 'rotate(' + rotateDegrees + 'deg)';
}

function setArms(){
  const armA = document.querySelector('.arm-a');
  const armB = document.querySelector('.arm-b');
  const armC = document.querySelector('.arm-c');

  // arm angle a 
  armA.style.left = saddleAnchor().x + 'px';
  armA.style.top = saddleAnchor().y + 'px';
  armA.style.right = imageContainer.width - ( saddleAnchor().x + ( dimensionB2() * ratio ) ) + 'px';

  // arm angle b
  // this needs to be calculed differently depending on if there is a negative saddleAngle or not
  if ( saddleAngle() > 0 ) {
    armB.style.bottom = imageContainer.width - saddleAnchor().y + 'px';
    armB.style.right = imageContainer.width - ( saddleAnchor().x + ( dimensionB2() * ratio ) ) + 'px';
    armB.style.top = ( saddleAnchor().y - ( dimensionA2() * ratio) ) + 'px';
  } else {
    armB.style.top = saddleAnchor().y + 'px';
    armB.style.right = imageContainer.width - ( saddleAnchor().x + ( dimensionB2() * ratio ) ) + 'px';
    armB.style.bottom = imageContainer.width - ( saddleAnchor().y - ( dimensionA2() * ratio) ) + 'px';
  }
  
  // arm angle c
  armC.style.left = saddleAnchor().x + 'px';
  armC.style.top = saddleAnchor().y + 'px';
  armC.style.right = imageContainer.width - ( saddleAnchor().x + ( dimensionC2() * ratio ) ) + 'px';
  armC.style.transform = 'rotate(' + -saddleAngle() + 'deg)';
}

// torso calculations
function torsoA() {
  const topCalc = ( (torsoLength() ** 2) + (dimensionC2() ** 2) ) - ( armLength() ** 2 );
  const bottomCalc = 2 * torsoLength() * dimensionC2();

  return 57.2958 * Math.acos(topCalc / bottomCalc);
}

function torsoB() {
  const topCalc = ( (armLength() ** 2) + (dimensionC2() ** 2) ) - ( torsoLength() ** 2 );
  const bottomCalc = 2 * armLength() * dimensionC2();

  return 57.2958 * Math.acos(topCalc / bottomCalc);
}

function torsoC() {
  return 0;
}

function setTorso() {
  const torso = document.querySelector('.torso');
  const arms = document.querySelector('.arms');
  const bodyImage = document.querySelector('.body-image');
  const armImage = document.querySelector('.arm-image');
  const headImage = document.querySelector('.head-image');

  // torso
  torso.style.left = saddleAnchor().x + 'px';
  torso.style.top = saddleAnchor().y + 'px';
  torso.style.right = imageContainer.width - ( saddleAnchor().x + ( torsoLength() * ratio ) ) + 'px';

  const torsoRotation = saddleAngle() + torsoA();

  torso.style.transform = 'rotate(' + -torsoRotation+ 'deg)';
  torsoReadOut.innerHTML = torsoRotation.toFixed(0) + ' degrees';

  // height of body image is difference in arm length and torso length, subtracted from top position of arm length
  bodyImage.style.left = saddleAnchor().x + 'px';
  bodyImage.style.top =  saddleAnchor().y  - (torsoLength() * ratio ) + 'px';
  bodyImage.style.bottom = imageContainer.width - ( saddleAnchor().y  ) + 'px';
  bodyImage.style.transform = 'translateX(-50%) rotate(' + (90 - torsoRotation) + 'deg)';


  // arms
  arms.style.bottom = imageContainer.width - ( saddleAnchor().y - ( dimensionA2() * ratio) ) + 'px';
  arms.style.right = imageContainer.width - ( saddleAnchor().x + ( dimensionB2() * ratio ) ) + 'px';
  arms.style.top = imageContainer.width - bb.y - ( ( armLength() + dimensionB() + dimensionA2() ) * ratio ) + 'px';

  armImage.style.bottom = imageContainer.width - ( saddleAnchor().y - ( dimensionA2() * ratio) ) + 'px';
  armImage.style.right = imageContainer.width - ( saddleAnchor().x + ( dimensionB2() * ratio ) ) + 'px';
  armImage.style.top = imageContainer.width - bb.y - ( ( armLength() + dimensionB() + dimensionA2() ) * ratio ) + 'px';

  let transformAngle = 0;
  if ( saddleAngle() < 0 ) {
    transformAngle = ( 90 - torsoB() + saddleAngle() ) * -1;
  } else {
    transformAngle = ( ( 90 - torsoB() ) + saddleAngle() ) * -1;
  }
  arms.style.transform = 'rotate(' + transformAngle + 'deg)';

  armImage.style.transform = 'translateX(50%) rotate(' + transformAngle + 'deg)';


  // head
  // calculate the head offset based on the torso length. the proportions of the drawings dictated the .37 multiplier
  const headOffset = (torsoLength() * ratio) * .37;

  headImage.style.left = saddleAnchor().x + 'px';
  headImage.style.top =  saddleAnchor().y  - (torsoLength() * ratio ) - headOffset + 'px';
  headImage.style.bottom = imageContainer.width - ( saddleAnchor().y  ) + 'px';
  headImage.style.transform = 'translateX(-50%) rotate(' + (90 - torsoRotation ) + 'deg)';
}

function writeMessage() {
  const message = document.querySelector('.message')
  const messages = {
    match: 'Both your inseam and your height match this model. It is a good choice for you.',
    inseamMatchHeightShort: 'Your inseam is within range for this size, but your height is below the range. That means it may feel like the handlebars are a long reach for you.',
    inseamMatchHeightTall: 'Your inseam is within range for this size, but your height is above the range. That means it may feel like the handlebars are too close to you.',
    inseamShortHeightMatch: 'You are within the height range for this size, but your inseam is too short. That means that you may have issues standing over the top tube of the bike, which could be unsafe.',
    inseamTallHeightMatch: 'You are within the height range for this size, but your inseam is too long. That means it may feel like the handlebars are low relative to your seat height.',
    noMatch: 'Neither your height or inseam is within the range for this bike. Consider a different option.'
  }
  if (model.match) {
    message.innerHTML = messages.match;
  } else if ( model.inseam == 0 && model.height < 0) {
    message.innerHTML = messages.inseamMatchHeightShort;
  } else if ( model.inseam == 0 && model.height > 0 ) {
    message.innerHTML = messages.inseamMatchHeightTall;
  } else if ( model.height == 0 && model.inseam < 0 ) {
    message.innerHTML = messages.inseamShortHeightMatch;
  } else if ( model.height == 0 && model.inseam > 0 ) {
    message.innerHTML = messages.inseamTallHeightMatch;
  } else {
    message.innerHTML = messages.noMatch
  }
}


// Add listeners to the avatar select buttons
function initAvatarButtons() {
  const avatarButtons = document.querySelectorAll('.avatar-btn');
  avatarButtons.forEach(function(button) {
    button.addEventListener('click', updateAvatar)
  })
}

function updateAvatar(e) {
  const avatarImages = document.querySelectorAll('.head-image img');
  const avatarButtons = document.querySelectorAll('.avatar-btn');
  avatarButtons.forEach((btn) => {
    btn.classList.remove('active');
  })
  e.target.classList.add('active');
  avatar = e.target.innerHTML.toLowerCase()
  console.log(avatarImages);
  avatarImages.forEach((image) => {
    if (image.dataset.hair == avatar) {
      image.style.display = 'block';
    } else {
      image.style.display = 'none';
    }
  })
}


// ------------ listeners for updating size inputs ---------------
function initSizeSelects() {
  const heightSelect = document.getElementById('height');
  const inseamSelect = document.getElementById('inseam');
  const wingspanSelect = document.getElementById('wingspan');
  
  heightSelect.addEventListener('change', function(e) {
    rider.height = e.target.value;
  })
  
  inseamSelect.addEventListener('change', function(e) {
    rider.inseam = e.target.value;
  })
  
  wingspanSelect.addEventListener('change', function(e) {
    rider.wingspan = e.target.value;
  })
}

// SADDLE HEIGHT SLIDER CONTROLS
// add listener to update on change
function initSaddleSlider() {
  document.getElementById('saddle-height-control').addEventListener('change', updateSaddleHeight);
}

// update min and max range values when new bike is loaded
function updateSliderRange() {

  // show slider
  const sliderControls = document.querySelector('.saddle-height');
  
  sliderControls.style.display = "block";

  var sliderMin = model.model[2] - -100;
  var sliderMax = inchesToMm(rider.inseam * .89);
  saddleHeightControl.min = sliderMin;
  saddleHeightControl.max = sliderMax;
  saddleHeightControl.value = inchesToMm(rider.inseam * .85)
  saddleHeightSlider = inchesToMm( parseInt(rider.inseam)) * .85;

  saddleReadOut.innerHTML = saddleHeightControl.value + 'mm';

}


function updateSaddleHeight() {
  saddleHeightSlider = saddleHeightControl.value;
  drawShapes();
  saddleReadOut.innerHTML = saddleHeightControl.value + 'mm';
}


// init functions / actions

initAvatarButtons();
initSizeSelects();
initSaddleSlider();
getSheetData();
document.querySelector('.recommend-btn').addEventListener('click', findSizeMatch)



// UTILITY FUNCTIONS
function saddleAnchor() { // this is where the rider's seat is, referenced in other functions
  let anchorObject = {
    x: bb.x - ( dimensionA() * ratio ),
    y: imageContainer.width - ( dimensionB() * ratio ) - bb.y
  }
  return anchorObject
}

// triangle 2 - seat to grip calc functions
function dimensionA2() { // vertical distance from saddle height to grips, can be negative if rider is too tall for the bike
  return bikeSpecs.gripStack - dimensionB();
}

function dimensionB2() { // horizontal distance between seat and handlebars
  const handlePosition = parseInt(bikeSpecs.gripReach) + parseInt(bikeSpecs.handleOffset);
  return ( handlePosition ) + dimensionA();
}

function dimensionC2() { // hypotenuse of triangle between A2 and B2 
  const aSquared = dimensionA2() ** 2;
  const cSquared = dimensionB2() ** 2;
  return Math.round(Math.sqrt(aSquared + cSquared));
}

function saddleAngle() {  // angle between seat and handlebars - can be negative if rider too tall for bike
  return 57.2958 * Math.atan(dimensionA2() / dimensionB2());
}

// bottom triangle - legs
function dimensionA() {
  const piRatio = Math.PI / 180;
  const degrees = 90 - bikeSpecs.angle;
  return Math.round(saddleHeightSlider * Math.sin( degrees * piRatio ));
}

function dimensionB() {
  const aSquared = dimensionA() ** 2;
  const cSquared = saddleHeightSlider ** 2;
  return Math.round(Math.sqrt(cSquared - aSquared));
}

// utility functions
function inchesToMm(inches) {
  return Math.round(inches * 25.4);
}

function torsoLength() {
  return Math.round(inchesToMm(rider.height) * .27);
}

function armLength() {
  return Math.round(inchesToMm(rider.wingspan) / 2.8);
}
